import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { useInView } from 'react-intersection-observer';

import mapStatAni from '../assets/gileadstats.svg';
import mapStatAniM from '../assets/gileadStatM.svg';
import mapStat1Legend from '../assets/mapStat1Legend.svg';
import mapStat1LegendM from '../assets/mapStat1LegendM.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    backgroundColor: '#1B1212',
    marginTop: '5rem',
    paddingBottom: '8rem',
    [theme.breakpoints.down('md')]: {
      marginTop: '16.8rem'
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      paddingTop: '5.9rem'
    }
  },
  header: {
    width: '48%',
    [theme.breakpoints.down('md')]: {
      width: '74%'
    }
  },
  legend: {
    marginTop: '2.3rem'
  },
  bgCont: {
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  numStatCont: {
    width: '100%',
    marginTop: '3.5rem',
    zIndex: '2'
  },
  source: {
    marginTop: '1rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '.2rem'
    }
  },
  img: {
    width: '52.7%',
    [theme.breakpoints.down('md')]: {
      width: '75%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '98%'
    }
  },
  // ====================================================================================
  subhead3: {
    ...theme.typography.subhead3,
    textAlign: 'center'
  },
  caption1: {
    ...theme.typography.caption
  },
  link: {
    color: '#979797'
  }
}));

const MapStat1 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const { ref, inView } = useInView({ threshold: 0.5 });

  const renderer = (
    <img src={matchesSM ? mapStatAniM : mapStatAni} alt="statistic" className={classes.img} />
  );

  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper}>
      <Grid ref={ref} item className={classes.header}>
        <Typography className={classes.subhead3}>
          SOUTHERN POPULATION VS HIV RATES BY RACE, 2018
        </Typography>
      </Grid>
      <Grid item className={classes.legend}>
        <img src={matchesXS ? mapStat1LegendM : mapStat1Legend} alt="map legend" />
      </Grid>
      <Grid container alignItems="center" justifyContent="center" className={classes.numStatCont}>
        {inView ? renderer : null}
      </Grid>
      <Grid item className={classes.source}>
        <Typography className={classes.caption1}>
          <a
            href="https://map.aidsvu.org/map"
            target="_blank"
            rel="sponsored"
            className={classes.link}
          >
            Source: AIDSVu.org
          </a>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default MapStat1;
